import "air-datepicker/air-datepicker.css";
import "tippy.js/dist/tippy.css";

import AirDatepicker from "air-datepicker";
import MicroModal from "micromodal";
import localeEn from "air-datepicker/locale/en";
import moment from "moment";
import sanitizeHtml from "sanitize-html";

MicroModal.init({
	disableScroll: true,
});

// Page Element Declarations
const elements = {
	coolRoomDaysCount: document.querySelector(".cool-room__days-count"),
	coolRoomBooker: document.querySelector("section.cool-room-booker"),
	checkout: document.querySelector(
		".cool-room-booker #booking-checkout-wrapper"
	),
	cart: document.querySelector(".cool-room-booker form.cart"),
	calendar: document.querySelector(".cool-room-booker .ui-datepicker-calendar"),
	createAccountCheckbox: document.querySelector("#createaccount"),
	woocommercePriceAmount: document.querySelector(
		".cool-room-booker .wc-bookings-booking-cost"
	),
	woocommercePriceFragment: document.querySelector(
		".cool-room-booker .woocommerce-booking-price-fragment"
	),
	dateRange: document.querySelector(
		".cool-room-booker .woocommerce-booking-date-range"
	),
	termsModalClose: document.querySelector(
		"#booking-terms-modal button[data-micromodal-close]"
	),
	modalAgreeTermsButton: document.querySelector(".modal button.agree-terms"),
	bookingSummary: document.querySelector(".cool-room-booker .booking-summary"),
	loginModalTrigger: document.querySelector(
		'.cool-room-booker a[data-custom-open="login-modal"]'
	),
	loginModalClose: document.querySelector(
		".cool-room-booker #login-modal button[data-micromodal-close]"
	),
	pageLinks: Array.from(
		document.querySelectorAll(
			"main > section:not(.cool-room-booker) a.cta-button"
		)
	),
	bookingDurationButtons: document.querySelectorAll(
		"input[name=booking_duration]"
	),
	bookingSummary: document.getElementById("cool-rooms__booking-summary"),
	bookingSummaryOverlay: document.getElementById("booking-summary__overlay"),
	datePickers: document.querySelectorAll(
		"div[data-layout=inputs] .cool-room-datepicker"
	),
	removeButtons: document.querySelectorAll(".product-remove .remove"),
	coolRoomCart: document.getElementById("cool-room-cart"),
	coolRoomWrapper: document.getElementById("cool-room-collection"),
	dateInputStart: document.getElementById("cool-room-calendar--start"),
	dateInputEnd: document.getElementById("cool-room-calendar--end"),
	coolRoomCalendar: document.getElementById("cool-room__calendar-wrapper"),
	dateCheckButton: document.getElementById("cool-room-calendar-check"),
	coolRooms: document.querySelectorAll("button.product-card"),
	errorsWrapper: document.querySelector(".cool-room-calendar__errors"),
	overlay: document.getElementById("cool-room__overlay"),
	overlayText: document
		.getElementById("cool-room__overlay")
		.querySelector("p.heading"),
	collectionTime: document.querySelectorAll("input[name=collect]"),
	returnTime: document.querySelectorAll("input[name=return]"),
	returnTimes: document.querySelectorAll(
		".cool-room__return, .cool-room__collect"
	),
};

/**
 * Globals
 */

let START_DATE = {
	day: "",
	month: "",
	year: "",
};

let END_DATE = {
	day: "",
	month: "",
	year: "",
};

let DURATION = "";

const minDate = moment().add(1, "day");
const maxDate = moment().add(1, "year");

/**
 * Component Setup
 */

Array.from(elements.coolRooms).map((coolRoom) => {
	coolRoom.addEventListener("click", async () => {
		setOverlayText("Adding to Cart");
		showOverlay(true);
		const id = coolRoom.getAttribute("data-product");
		const results = await addItemToCart(id);
		if (results) {
			location.reload();
		}
	});
});

const datePicker = new AirDatepicker("#cool-room-calendar", {
	autoClose: true,
	locale: localeEn,
	inline: true,
	range: true,
	firstDay: 1,
	dateFormat: "dd/MM/yyyy",
	minDate: minDate,
	maxDate: maxDate,
	onRenderCell({ date, cellType }) {
		if (cellType === "day") {
			if (date.getDay() === 0 || date.getDay() === 6) {
				return {
					disabled: true,
				};
			}
		}
	},
	onSelect({ date }) {
		const [start = null, end = null] = date;
		if (start && end) {
			updateBookingDuration(start, end);
			elements.dateCheckButton.disabled = false;
		}
	},
});

Array.from(elements.datePickers).forEach((datePicker) => {
	new AirDatepicker(datePicker, {
		autoClose: true,
		locale: localeEn,
		inline: false,
		range: false,
		firstDay: 1,
		dateFormat: "dd/MM/yyyy",
		minDate: minDate,
		maxDate: maxDate,
		onRenderCell({ date, cellType }) {
			if (cellType === "day") {
				if (date.getDay() === 0 || date.getDay() === 6) {
					return {
						disabled: true,
					};
				}
			}
		},
		onSelect({ date }) {
			const errors = validateDates();
			renderErrors(errors);
			elements.dateCheckButton.disabled = errors.length;
			if (!errors.length) {
				updateBookingDuration(
					moment(elements.dateInputStart.value, "DD/MM/YYYY"),
					moment(elements.dateInputEnd.value, "DD/MM/YYYY")
				);
			}
		},
	});
});

/**
 * Event Listeners
 */

elements.collectionTime.forEach((element) => {
	element.addEventListener("input", (e) => {
		updateBookingDuration(...datePicker.selectedDates);
		updateCollectReturnTimes(e);
	});
});

// Attach event listeners to each return time input
elements.returnTime.forEach((element) => {
	element.addEventListener("input", (e) => {
		updateBookingDuration(...datePicker.selectedDates);
		updateCollectReturnTimes(e);
	});
});

document.addEventListener("DOMContentLoaded", () => {
	if (elements.coolRoomCart.getAttribute("data-has-booking") === "true") {
		elements.coolRoomCart.scrollIntoView({ behavior: "smooth" });
	}
});

document.addEventListener("click", (e) => {
	if (e.target.getAttribute("id") === "create-account-dummy") {
		if (elements.createAccountCheckbox) {
			elements.createAccountCheckbox.checked = e.target.checked;
		}
	}
	if (
		e.target.getAttribute("id") === "terms" ||
		e.target.classList.contains("woocommerce-terms-and-conditions-link")
	) {
		e.preventDefault();
		MicroModal.show("booking-terms-modal");
	}
	if (e.target.classList.contains("agree-terms")) {
		elements.termsCheckbox = document.getElementById("terms");
		elements.termsCheckbox.checked = !elements.termsCheckbox.checked;
		MicroModal.close("booking-terms-modal");
		elements.modalAgreeTermsButton.textContent = elements.termsCheckbox.checked
			? "I disagree"
			: "I agree";
	}
	if (e.target.classList.contains("remove")) {
		e.preventDefault();
	}
});

elements?.pageLinks?.map((pageLink) => {
	pageLink.addEventListener("click", (e) => {
		if (e.target.getAttribute("href") === "#") {
			e.preventDefault();
			elements.coolRoomBooker.scrollIntoView({
				behavior: "smooth",
			});
		}
	});
});

elements.loginModalTrigger?.addEventListener("click", () => {
	MicroModal.show("login-modal");
});

elements.loginModalClose?.addEventListener("click", () => {
	MicroModal.close("login-modal");
});

elements.termsModalClose?.addEventListener("click", () => {
	MicroModal.close("booking-terms-modal");
});

jQuery(document).ajaxComplete(async function (event, xhr, settings) {
	if (settings.url.includes("wc-ajax=update_order_review")) {
		showBookingOverlay(true);
		await updateBookingSummary();
		showBookingOverlay(false);
	}
});

elements?.dateCheckButton?.addEventListener("click", async () => {
	let end;
	let startDate;
	let endDate;
	let bookingStart;
	let bookingEnd;

	[startDate, endDate] = datePicker.selectedDates;
	const collectionTime = Array.from(elements.collectionTime).find(
		(r) => r.checked
	).value;
	const returnTime = Array.from(elements.returnTime).find(
		(r) => r.checked
	).value;

	bookingStart = moment(startDate).add(
		collectionTime === "PM" ? 12 : 0,
		"hours"
	);
	bookingEnd = moment(endDate).add(returnTime === "PM" ? 24 : 12, "hours");
	DURATION = bookingEnd.diff(bookingStart, "hours", true) / 12;

	setCheckButtonLoading(true);
	setOverlayText("Checking Availability");
	showOverlay(true);

	START_DATE.day = bookingStart.format("DD");
	START_DATE.month = bookingStart.format("MM");
	START_DATE.year = bookingStart.format("YYYY");
	START_DATE.time = bookingStart.format("HH:mm:ss");
	START_DATE.date_time = bookingStart.format("YYYY-MM-DDTHH:mm:ssZ");
	END_DATE.day = bookingEnd.format("DD");
	END_DATE.month = bookingEnd.format("MM");
	END_DATE.year = bookingEnd.format("YYYY");
	END_DATE.time = bookingEnd.format("HH:mm:ss");

	await fetchAllBookingProductSlots(
		bookingStart.format("YYYY-MM-DD"),
		bookingEnd.format("YYYY-MM-DD"),
		"Australia/Melbourne"
	)
		.then((data) => {
			availabilityMap = data;
			elements.coolRoomCalendar.setAttribute("data-has-dates", true);
			elements.coolRoomWrapper.scrollIntoView({
				behavior: "smooth",
			});
		})
		.catch((error) => console.error("Fetch error:", error))
		.finally(() => {
			showOverlay(false);
			setCheckButtonLoading(false);
		});
	updateUI(availabilityMap);
});

elements.removeButtons?.forEach((removeButton) => {
	removeButton.addEventListener("click", (e) => {
		e.preventDefault();
	});
});

function updateCollectReturnTimes(e) {
	elements.returnTimes.forEach((item) => {
		const classString = Array.from(item.classList).join(" ");
		if (
			classString.includes(`cool-room__${e.target.name}`) &&
			classString.includes(
				`cool-room__${e.target.name}--${e.target.value.toLowerCase()}`
			)
		) {
			item.setAttribute("data-active", "true");
			return;
		}

		document
			.querySelector(
				`.cool-room__${e.target.name}--${e.target.value === "PM" ? "am" : "pm"}`
			)
			.setAttribute("data-active", "false");
	});
}

function updateBookingDuration(start, end) {
	const collectionTime = Array.from(elements.collectionTime).find(
		(r) => r.checked
	).value;
	const returnTime = Array.from(elements.returnTime).find(
		(r) => r.checked
	).value;

	const bookingStart = moment(start).add(
		collectionTime === "PM" ? 12 : 0,
		"hours"
	);
	const bookingEnd = moment(end).add(returnTime === "PM" ? 12 : 0, "hours");

	const days = Math.ceil(bookingEnd.diff(bookingStart, "days", true));

	elements.coolRoomDaysCount.setAttribute("data-updating", "true");
	setTimeout(() => {
		elements.coolRoomDaysCount.innerHTML = "";
		elements.coolRoomDaysCount.innerHTML = `<span class = "font-bold">Booking Duration: </span><span>${sanitizeHtml(days)} day(s)</span>`;
		elements.coolRoomDaysCount.setAttribute("data-updating", "false");
	}, [400]);
}

function showOverlay(status) {
	elements.overlay.setAttribute("data-active", status ? "true" : "false");
}

function setOverlayText(text) {
	elements.overlayText.innerHTML = "";
	elements.overlayText.innerHTML = sanitizeHtml(text);
}

function showBookingOverlay(status) {
	elements.bookingSummaryOverlay.setAttribute(
		"data-active",
		status ? "true" : "false"
	);
}

async function addItemToCart(id) {
	setOverlayText("Adding to Cart");
	showOverlay(true);

	const formData = new FormData();
	formData.append("action", "pp_add_to_cart");
	formData.append("nonce", window.wcopc.wcopc_nonce);
	formData.append(
		"input_data",
		`wc_bookings_field_start_date_month=${START_DATE.month}&wc_bookings_field_start_date_day=${START_DATE.day}&wc_bookings_field_start_date_year=${START_DATE.year}&start_time=${encodeURIComponent(START_DATE.date_time)}&end_time=${DURATION}&wc_bookings_field_duration=${DURATION}&wc_bookings_field_start_date_time=${encodeURIComponent(START_DATE.date_time)}&wc_bookings_field_start_date_local_timezone=&is-descendent-of-single-product-block=false&min_date=${minDate}&max_date=${maxDate}&timezone_offset=0`
	);
	formData.append("add_to_cart", id);

	try {
		const response = await fetch(`/wp-admin/admin-ajax.php`, {
			method: "POST",
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const result = await response.json();
		return result;
	} catch (error) {
		console.error("Error adding to cart:", error);
		throw error;
	}
}

/**
 * Custom Functions
 */

async function getBookingPrice(productId) {
	const url = "/wp-admin/admin-ajax.php";

	const formData = new FormData();
	formData.append("action", "wc_bookings_calculate_costs");
	formData.append(
		"form",
		`wc_bookings_field_start_date_month=${START_DATE.month}&wc_bookings_field_start_date_day=${START_DATE.day}&wc_bookings_field_start_date_year=${START_DATE.year}&start_time=${encodeURIComponent(START_DATE.date_time)}&end_time=${DURATION}&wc_bookings_field_duration=${DURATION}&wc_bookings_field_start_date_time=${encodeURIComponent(START_DATE.date_time)}&wc_bookings_field_start_date_local_timezone=&add-to-cart=${productId}&is-descendent-of-single-product-block=false&min_date=${minDate.format("YYYY-MM-DD")}&max_date=${maxDate.format("YYYY-MM-DD")}&timezone_offset=0`
	);
	//OLD `wc_bookings_field_duration=${DURATION}&wc_bookings_field_start_date_month=${startMonth}&wc_bookings_field_start_date_day=${startDay}&wc_bookings_field_start_date_year=${startYear}&wc_bookings_field_start_date_to_month=${endMonth}&wc_bookings_field_start_date_to_day=${endDay}&wc_bookings_field_start_date_to_year=${endYear}&add-to-cart=${productId}&min_date=${minDate}&max_date=${maxDate}&timezone_offset=0`

	try {
		const response = await fetch(`${url}`, {
			method: "POST", // Use 'POST' if the endpoint expects a POST request
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const result = await response.json();
		return result;
	} catch (error) {
		console.error("Error calculating booking costs:", error);
		throw error;
	}
}

/**
 *
 * @param {*} startDate
 * @param {*} endDate
 * @param {*} timeZone
 * @returns
 *
 * Fetches booking product data including pricing and availability.
 */

async function fetchAllBookingProductSlots(
	startDate,
	endDate,
	timeZone = "UTC"
) {
	const url = `/wp-json/wc-bookings/v1/products/slots`;
	const resultsPerPage = 10;
	let currentPage = 1;
	let totalResults = [];
	let totalPages = 1; // Initialize totalPages to 1 as a fallback

	try {
		while (currentPage <= totalPages) {
			// Construct query parameters
			const queryParams = new URLSearchParams({
				min_date: startDate,
				max_date: endDate === startDate ? "" : endDate,
				page: currentPage,
				per_page: resultsPerPage,
				timezone: timeZone,
			}).toString();

			const response = await fetch(`${url}?${queryParams}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const data = await response.json();

			totalResults = totalResults.concat(data.records);
			totalPages = Math.ceil(data.count / resultsPerPage);
			currentPage++;
		}

		// DURATION = moment(endDate, "YYYY-MM-DD").diff(
		// 	moment(startDate, "YYYY-MM-DD"),
		// 	"days"
		// );

		const availabilityMap = await createAvailabilityMap(totalResults, DURATION);

		return availabilityMap;
	} catch (error) {
		console.error("Error fetching booking product slots:", error);
		throw error; // Re-throw the error if you want to handle it further up the call chain
	}
}

/**
 * Takes the existing map that shows product availability, and if available
 * gets the total cost of that booking.
 */
async function addPricesToMap(availabilityMap, duration) {
	for (const [key, { available }] of availabilityMap) {
		if (available) {
			const price = await getBookingPrice(key);
			if (price) {
				availabilityMap.set(key, { available, price });
			}
		}
	}
}

async function createAvailabilityMap(slots, duration) {
	const availabilityMap = new Map();

	slots.forEach((slot) => {
		const productId = slot.product_id;
		const isAvailable = slot.available > 0;

		if (!availabilityMap.has(productId)) {
			availabilityMap.set(productId, { available: true }); // Default to true
		}

		if (!isAvailable) {
			//Check if we are making a PM booking on the same day.
			if (
				!moment(START_DATE.date_time, "YYYY-MM-DDTHH:mm:ssZ").isAfter(
					moment(slot.date, "YYYY-MM-DDTHH:mm")
				)
			) {
				availabilityMap.set(productId, { available: false }); // Set to false if this slot is not available
			}
		}
	});

	await addPricesToMap(availabilityMap, duration);

	return availabilityMap;
}

function setCheckButtonLoading(status) {
	elements.dateCheckButton.disabled = status;
	elements.dateCheckButton.setAttribute(
		"data-loading",
		status ? "true" : "false"
	);
}

async function updateBookingSummary() {
	try {
		const response = await fetch(
			"/wp-admin/admin-ajax.php?action=update_booking_summary"
		);
		const { success, data } = await response.json();
		if (success) {
			elements.bookingSummary.innerHTML = sanitizeHtml(data, {
				allowedAttributes: {
					"*": ["class", "href", "id"],
				},
				allowedTags: sanitizeHtml.defaults.allowedTags.concat("div"),
			});
		} else {
			console.error("Error fetching cart fragment:", data.data);
		}
	} catch (error) {
		console.error("AJAX error:", error);
	}
}

function renderErrors(errors) {
	const errorsWrapper = elements.errorsWrapper; // Assuming this is already defined

	// Clear previous errors
	errorsWrapper.innerHTML = "";

	if (errors.length > 0) {
		// Create a new unordered list
		const ul = document.createElement("ul");

		// Iterate over the errors array and create list items
		errors.forEach((error) => {
			const li = document.createElement("li");
			li.textContent = error; // Set the text content to the error message
			ul.appendChild(li); // Append the list item to the unordered list
		});

		// Append the unordered list to the errorsWrapper
		errorsWrapper.appendChild(ul);
	}
}

function validateDates() {
	const startDate = moment(elements.dateInputStart.value, "DD/MM/YYYY");
	let endDate = elements.dateInputEnd.value
		? moment(elements.dateInputEnd.value, "DD/MM/YYYY")
		: null;
	const errors = [];

	if (startDate.isSame(endDate)) {
		errors.push("Bookings must be for a minimum of one day");
	}

	if (!startDate || !endDate) {
		errors.push("You must include a start date and end date");
	}

	if (startDate.day() === 5 && endDate.day() === 5) {
		errors.push("Single day Friday bookings must be booked over the weekend");
	}

	if (!startDate.isValid() || !endDate.isValid()) {
		errors.push("Dates are not in a valid format");
	}
	if (startDate.isAfter(endDate)) {
		errors.push("Start date must be before your end date");
	}

	if (startDate.isBefore(moment()) || endDate.isBefore(moment())) {
		errors.push("Bookings must be made in the future.");
	}

	return errors;
}

function updateUI(availabilityMap) {
	if (!availabilityMap.length) {
		//Handle if no matching records.
		elements.coolRooms.forEach((coolRoom) => {
			coolRoom.disabled = true;
			coolRoom.setAttribute("data-active-product", "false");
			coolRoom.querySelector(".product-booking-price").innerHTML =
				"Unavailable";
		});
	}
	for (const [key, { available, price }] of availabilityMap.entries()) {
		const element = document.querySelector(
			`button.product-card[data-product="${key}"]`
		);
		if (element) {
			element.disabled = !available || price?.result === "ERROR";
			element.setAttribute(
				"data-active-product",
				available && price?.result === "SUCCESS" ? "true" : "false"
			);
			element.querySelector(".product-booking-price").innerHTML =
				available && price?.result === "SUCCESS"
					? sanitizeHtml(price?.html)
					: "Unavailable";
		}
	}
}
